/**
 * Credits Icon Component
 * 
 * Centralized SVG icon for credits display across the app.
 * Two overlapping circles representing coins/tokens.
 */

import React from 'react';

interface CreditsIconProps {
  size?: number;
  color?: string;
  className?: string;
}

export const CreditsIcon: React.FC<CreditsIconProps> = ({ 
  size = 16, 
  color = 'currentColor',
  className = ''
}) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 16 16" 
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <path 
      d="M6.68702 2.14977C7.56468 1.43117 8.68675 1 9.90952 1C12.7209 1 15 3.27928 15 6.09091C15 7.31323 14.5693 8.43494 13.8513 9.3125M11.181 9.90909C11.181 12.7207 8.90187 15 6.09048 15C3.27908 15 1 12.7207 1 9.90909C1 7.09746 3.27908 4.81818 6.09048 4.81818C8.90187 4.81818 11.181 7.09746 11.181 9.90909Z" 
      stroke={color} 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

export default CreditsIcon;
